<template>
  <div class="falcon-upload">
    <el-upload
      :class="['upload-demo', {'no': fileList.length == limit}]"
      ref="upload"
      action=""
      :multiple="multiple"
      :auto-upload="auto"
      :limit="limit"
      :list-type="listStyle"
      :file-list="fileList"
      :accept="accept"
      :on-preview="handlePreview"
      :before-upload="beforeUpload"
      :on-change="handleChange"
      :before-remove="beforeRemove"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
    >
      <slot name="content">
        <i v-if="!isFile" class="el-icon-plus"></i>
        <el-button v-else type="primary" size="mini">上传文件</el-button>
      </slot>
    </el-upload>
    <!-- 图片预览 -->
    <el-dialog width="40%" :visible.sync="dialogVisible" :modal="isShowModal">
      <div style="text-align: center;">
        <img style="max-width: 100%;" :src="dialogImageUrl" alt="图片" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {isAssetTypeAnImage} from '@/utils/func';
export default {
  props: {
    // 是否验证文件格式
    isAccept: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: ".jpg,.jpeg,.png,.JPG,.JPEG",
    },
    listStyle: {
      type: String,
      default: "picture-card",
    },
    limit: {
      type: Number,
      default: 1,
    },
    auto: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    fileListData: [String, Object, Array ],
    fileLists: {
      type: Array,
      default: () => [],
    },
    isFileListData: {
      type: Boolean,
      default: false,
    },
    // 是否显示查看图片时的遮罩层(避免弹窗时点击遮罩层覆盖)
    isShowModal: {
      type: Boolean,
      default: true,
    },
    // 是否上传文件(除图片格式外的文件)
    isFile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
      dialogVisible: false,
      dialogImageUrl: "",
      fileList: [],
    };
  },
  watch: {
    fileLists: {
      immediate: true,
      handler(newV){
        if(newV.length == 0){
          this.fileList = [];
        }
      },
    },
  },
    mounted() {
      let a = setTimeout(() => {
          if(this.isFileListData){
            // console.log(this.fileListData);
            this.fileListDataCl(this.fileListData);
            return;
          }
          this.fileList = this.fileLists;
          clearTimeout(a);
      }, 500);
    },
    methods: {
        fileListDataCl(newVal) {
            if(!newVal || !newVal[0]) return;
            this.fileList = [];
            if(typeof(newVal) === 'string') {
                newVal.split(',').forEach(val =>{
                    this.fileList.push({
                        url: val
                    });
                });
                return;
            }
            if(typeof(newVal) === 'object') {
                newVal.forEach(val => {
                    this.fileList.push({
                        url: val.value
                    });
                });
            }
        },
    // 限制文件格式、大小
    beforeUpload(file) {
      if(this.isAccept){
        let type = file.name.substring(file.name.lastIndexOf("."));
        let acceptArr = this.accept.split(",");
        if (acceptArr.indexOf(type) == -1) {
          this.$message({
            message: `上传文件只能是${this.accept}格式!`,
            type: "warning",
          });
          return false;
        }
      }
      // const isLt10M = file.size / 1024 / 1024 < 100;
      // if (!isLt10M) {
      //   this.$message.error("上传文件大小不能超过 100MB!");
      //   return false;
      // }
      return true;
    },
    // 限制文件数量
    handleExceed() {
        this.$message.warning(`当前限制只能上传 ${this.limit} 个文件`);
    },
    // 上传
    handleChange(file, fileList) {
      // if(!this.auto){
      //   let isUpload = this.beforeUpload(file);
      //   if(!isUpload){
      //     this.fileList = this.fileList.map(item => item.name !== file.name); 
      //     return;
      //   };
      // }
      const data = {
        file,
        fileList,
      };
      this.fileList = fileList;
      this.$emit("handleChange", data);
    },
    // 删除
    beforeRemove(file) {
      // console.log(file);
      // return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      const data = {
        file,
        fileList,
      };
      this.$emit("handleRemove", data);
    },
    // 预览
    handlePreview(file) {
      if(!this.isFile){
        // let type = file.name.substring(file.name.lastIndexOf("."));
        // let acceptArr = type.split(".")[1];
        // if(isAssetTypeAnImage(acceptArr)){
          this.dialogVisible = true;
          this.dialogImageUrl = file.url;
          this.$emit("handlePreview", file);
        // }
      }
    },
    // 清空
    reset() {
      this.fileList = [];
    },
  },
};
</script>

<style lang="scss">
.falcon-upload {
  .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;

    .el-icon-plus {
      line-height: inherit;
    }
  }

  .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    margin: 0 8px 8px 0;
    display: inline-block;
  }
  .upload-demo.no{
    .el-upload--picture-card{
      display: none;
    }
  }
}
</style>
